// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6415":"891507be5be60f68","9661":"46d3b58650fbf82b","9894":"df6dba095f8d61ef"}[chunkId] + ".js";
};